<template>
    <div>

        <!-- Confirmation Dialogs -->
        <ConfirmDialog
            key="confirm-dialog"
            v-show="dialog.dialogType === 'confirm'"
            :is-open="dialog.isOpen && dialog.dialogType === 'confirm'"
            v-bind="dialog.dialogProps"
            @confirm="handleConfirmWrapper"
            @cancel="handleCancelWrapper"
            @update:open="dialog.handleUpdateOpen" />

        <!-- Error Dialogs -->
        <ErrorDialog 
            key="error-dialog" 
            v-show="dialog.dialogType === 'error'" 
            :is-open="dialog.isOpen && dialog.dialogType === 'error'"
            v-bind="dialog.dialogProps" 
            @update:open="dialog.handleUpdateOpen" />
    </div>
</template>

<script setup>
import { inject } from 'vue';
import ConfirmDialog from './ConfirmDialog.vue';
import ErrorDialog from './ErrorDialog.vue';

// Inject the global dialog state
const globalDialog = inject('globalDialog');

if (!globalDialog) {
    console.error('GlobalDialog injection failed - dialog system will not work');
}

// Don't destructure - keep reactive references
const dialog = globalDialog || {};

const handleConfirmWrapper = (result) => {
    if (dialog.handleConfirm) {
        dialog.handleConfirm(result);
    }
};

const handleCancelWrapper = (result) => {
    if (dialog.handleCancel) {
        dialog.handleCancel(result);
    }
};

</script>
